import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import YoutubeEmbed from "../components/YoutubeEmbed";
import MenuHamburger from "../components/MenuHamburger"
import Footer from "../components/Footer";
import ImageCarousel from "../components/ImageCarousel"
import { Helmet } from 'react-helmet';
import Waveform from "../components/WaveForm";
import PlayList from "../components/Playlist";

export const MediaDE = () => {
    
    const [activeContent, setActiveContent] = useState("photos"); 
    const [mediaLoaded, setMediaLoaded] = useState(false);
    const [photosVisible, setPhotosVisible] = useState(false);
    const [videosVisible, setVideosVisible] = useState(false); 
    const [audiosVisible, setAudiosVisible] = useState(false); 
    const [showMenuHamburger, setShowMenuHamburger] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [language, setLanguage] = useState("de");
    const [selectedImage, setSelectedImage] = useState(null);
    const [isCarouselVisible, setCarouselVisibility] = useState(true);

    const photos = [
      {id:1, src:"../photos/DSCF6608-2.webp" },
      {id:2, src:"../photos/DSCF6734-2.webp" },
      {id:3, src: "../photos/DSCF6689.webp" },  
      {id:4, src:"../photos/DSCF7486.webp" },
      {id:5, src:"../photos/DSCF6830-2.webp" },
      {id:6, src:"../photos/DSCF6974-2.webp" },
      {id:7, src:"../photos/DSCF7067-2.webp" },
      {id:8, src: "../photos/DSCF7067.webp" },
      {id:9, src: "../photos/DSCF7459-2.webp" },
      {id:10, src: "../photos/DSCF6675-2.webp" },
    ];

    const tracks = [
      {
        id: 0,
        title: "L. Janacek - Sonata for Violin and Piano - 1 movement - Con moto, Dmytro Udovychenko and Tetiana Bielikova, Campus Konzert WDR 3",
        url:
          "/audio/L. Janacek - Sonata for Violin and Piano - 1 movement - Con moto (Dmytro Udovychenko and Tetiana Bielikova, Campus Konzert WDR 3).mp3"
      },
      {
        id: 1,
        title: "L. Janacek - Sonata for Violin and Piano - 4 movement - Adagio, Dmytro Udovychenko - Tetiana Bielikova, Campus Konzert WDR 3",
        url:
          "/audio/L. Janacek - Sonata for Violin and Piano - 4 movement - Adagio (Dmytro Udovychenko and Tetiana Bielikova - Campus Konzert WDR 3).mp3"
      },
      {
        id: 2,
        title: "W. Lutoslawski - Subito, Dmytro Udovychenko - Tetiana Bielikova, Campus Konzert WDR 3",
        url:
          "/audio/W. Lutoslawski - Subito (Dmytro Udovychenko and Tetiana Bielikova, Campus Konzert WDR 3.mp3"
      }
    ];

    const [selectedTrack, setSelectedTrack] = useState(tracks[0]);

    const handleImageSelect = (image) => {
      setSelectedImage(image);
      document.body.classList.add('no-scroll');
    };
    
    const handleCloseClick = () => {
      setCarouselVisibility(false);
      document.body.classList.remove('no-scroll');
    };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setShowMenuHamburger(false);
      } else {
        setShowMenuHamburger(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

    const handleContentChange = (content) => {
        setActiveContent(content);
        setPhotosVisible(false);
        setVideosVisible(false);
        setAudiosVisible(false);
    };
        
    const handleMediaLoaded = () => {
        setMediaLoaded(true);
    };
    
    useEffect(() => {
        if (activeContent === "photos") {
          setTimeout(() => {
            setPhotosVisible(true);
          }, 500);
        } else if (activeContent === "videos") {
          setTimeout(() => {
            setVideosVisible(true);
          }, 1500);
        } else if (activeContent === "audios") {
          setTimeout(() => {
            setAudiosVisible(true);
          }, 1500);
        }
      }, [activeContent]);    

    return (
      <>
      <Helmet>
        <title>Tetiana Bielikova | Media</title>
        <meta name="description" content="Photos-Videos-Audio" />
      </Helmet>
        <div className="media-container">
          {showMenuHamburger && <MenuHamburger isMenuOpen={isMenuOpen} isMediaPage={true} language={language}/>}
          {!showMenuHamburger && <Header isMediaPage={true} language={language} />}
          <div className="media-body">
            <div className="media-wrapper">
                <div className="media-name-container">
                    <h1 className="media-title">Media</h1>
                    <div className="line3"></div>
                </div>
                <div className="button-container">
                    <a className={`btn-media ${activeContent === "photos" ? "active" : ""}`}
                    onClick={() => handleContentChange("photos")} >FOTOS</a>
                    <a className={`btn-media ${activeContent === "videos" ? "active" : ""}`}
                    onClick={() => handleContentChange("videos")} >VIDEOS</a>
                    <a className={`btn-media ${activeContent === "audios" ? "active" : ""}`}
                    onClick={() => handleContentChange("audios")} >AUDIO</a>
                </div>
                <a href="https://dl.dropboxusercontent.com/scl/fi/c6p14f71r1iwtinvpslhj/tetiana_bielikova_presskit.zip?rlkey=fjwgxs5qg695q4gj3pcj8km9g&dl=0" className="contact-links-container margin-big media-link" target="_blank">
                  <span className='hover-links links-contact media-link' ><svg width="1.7em" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 17L12 20M12 20L15 17M12 20V12M4 15.6458C3.70865 15.3154 3.47348 14.9387 3.30448 14.5307C3.10346 14.0454 3 13.5253 3 13C3 12.4747 3.10346 11.9546 3.30448 11.4693C3.5055 10.984 3.80014 10.543 4.17157 10.1716C4.54301 9.80014 4.98396 9.5055 5.46927 9.30448C5.95457 9.10346 6.47471 9 7 9C7 8.34339 7.12933 7.69321 7.3806 7.08658C7.63188 6.47996 8.00017 5.92876 8.46447 5.46447C8.92876 5.00017 9.47996 4.63188 10.0866 4.3806C10.6932 4.12933 11.3434 4 12 4C12.6566 4 13.3068 4.12933 13.9134 4.3806C14.52 4.63188 15.0712 5.00017 15.5355 5.46447C15.9998 5.92876 16.3681 6.47996 16.6194 7.08658C16.8707 7.69321 17 8.34339 17 9C17.5253 9 18.0454 9.10346 18.5307 9.30448C19.016 9.5055 19.457 9.80014 19.8284 10.1716C20.1999 10.543 20.4945 10.984 20.6955 11.4693C20.8965 11.9546 21 12.4747 21 13C21 13.5253 20.8965 14.0454 20.6955 14.5307C20.5265 14.9387 20.2913 15.3154 20 15.6458" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>
                  <span className='hover-links links-contact'>Download Presskit</span>
                </a>   
                {activeContent === "photos" && (
                  <div className={`photos-container ${photosVisible ? "visible" : ""}`}>
                    {photos.map((image) => (
                      <img
                        key={image.id}
                        src={image.src}
                        className="photos-media"
                        loading="lazy"
                        alt="Tetiana-Bielikova-media"
                        onClick={() => {
                          setSelectedImage(image);
                          setCarouselVisibility(true);
                        }}                  
                      />
                    ))}
                  </div>
                )}
                {activeContent === "videos" && (
                <div className={`videos-container ${videosVisible ? "visible" : ""}`}>
                  <YoutubeEmbed onLoad={handleMediaLoaded} 
                  title="Scriabin - Etude Op. 8 No. 12" 
                  embedId="Vgp04fTA8js"/>
                  <YoutubeEmbed onLoad={handleMediaLoaded} 
                  title="Nicolai Medtner (1880-1951): Fairy Tale Op. 23 N. 3"
                  embedId="1MAXzDULNhk" />
                  <YoutubeEmbed onLoad={handleMediaLoaded} 
                  title="William Albright - Sonata for Alto saxophone and Piano"
                  embedId="QOmww5zQKUA" />
                </div>
                )}
                {activeContent === "audios" && (
                                <div className={`audios-container ${audiosVisible ? "visible" : ""}`}>
                                <Waveform url={selectedTrack.url} />
                                <PlayList
                                  tracks={tracks}
                                  selectedTrack={selectedTrack}
                                  setSelectedTrack={setSelectedTrack}
                                />
                              </div>
                )}
            </div>
          </div>
          {selectedImage && isCarouselVisible && (
          <ImageCarousel 
            selectedImage={selectedImage} 
            photos={photos} 
            onCloseClick={handleCloseClick}
          />
          )}
        <Footer />
      </div>
    </>
  );
};

export default MediaDE;